import { render, staticRenderFns } from "./moderation.vue?vue&type=template&id=a7d7c16e&scoped=true"
import script from "./moderation.vue?vue&type=script&lang=js"
export * from "./moderation.vue?vue&type=script&lang=js"
import style0 from "./moderation.vue?vue&type=style&index=0&id=a7d7c16e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d7c16e",
  null
  
)

export default component.exports